import axios from 'axios';
import Vue from 'vue'
import store from '../store/index'
import { Toast } from 'vant';
let state = true
const ajax = axios.create({
  //测试
  // baseURL: 'http://test2.baozheng.cc/open/api/',
  //生产
  baseURL: process.env.VUE_APP_URL,
  // baseURL:"https://mi.baozheng.cc/open/api/",
  timeout: 6000,
});
//
ajax.interceptors.request.use(config => {
    let token = localStorage.getItem('token');
    if(token){
        config.headers.Authorization = 'Bearer ' + token;
    }
    if(!config.headers.NO_LOADING){
      state = true
      if (state) {
        Toast.loading({
          message: '拼命加载中...',
          duration: 0,
          forbidClick: true, // 禁用背景点击
          // loadingType: 'spinner',
        })  
      }
    }
    return config
}, error => {
  Toast.clear();
  state = false
  console.log(error);
  Promise.reject(error);
});

ajax.interceptors.response.use(
  response => {
    state = false
    Toast.clear();
    const res = response.data;
    // alert(res.code)
    if (res.code === 200) {
      return res.data
    } else if(res.code === 400){
      if(res.message != 'UNAUTHORIZED'){
        Toast(res.message);
      }
      return Promise.reject(res)
    }else if(res.code === 401){
      // alert(JSON.stringify(res))
      //提示请登录
      
      sessionStorage.setItem('url', location.href)
      store.commit('setUserInfo', '');
      localStorage.clear();
      location.replace(location.origin + '/login');
      return Promise.reject(res)
    }else if(res.code === 10086){
      return Promise.reject(res)
    }else if(res.code === 500){
      Toast(res.message);
      return Promise.reject(res)
    }else if(res.code === 10010){
      return Promise.reject(res)
    }else if(res.code === 110001){
      return Promise.reject(res)
    }else if(res.code === 10088){
      return Promise.reject(res)
    }else{
      return res
    }
  },
  error => {
    Toast.clear();
    const errorResponse = error.response;
    console.log(error);
    Toast('啊哦，你的网络好像飘到外太空了~');
    return Promise.reject(errorResponse)
  });

export default ajax
